<template>
  <v-app>
    <v-app-bar app fixed color="blue-grey"/>

    <v-content>
      <v-container>
        <router-view/>
      </v-container>
    </v-content>

    <v-snackbar v-model="snackbarDisplaying"
                :timeout="10000"
                :color="snackbar.color"
    >
      {{ snackbar.message }}
    </v-snackbar>

    <v-footer color="blue-grey" class="white--text" app>
      <v-spacer/>
      <span>
        {{ year }} — DIP — <strong>Direction du numérique</strong> - Version {{ version }} - {{ environment }}
      </span>
      <v-spacer/>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'App',

  data: () => ({
    snackbarDisplaying: false,
    version: process.env.PACKAGE_VERSION || '0',
    environment: process.env.VUE_APP_DEPLOYMENT_ENV,
    year: new Date().getFullYear(),
  }),

  computed: {
    ...mapGetters([
      'snackbar',
      'snackbarDisplayed',
    ]),
  },

  watch: {
    snackbarDisplayed () {
      if (this.snackbar.display) this.snackbarDisplaying = true
    },
    snackbarDisplaying () {
      if (!this.snackbarDisplaying) this.$store.dispatch('switchSnackbarStatus', false)
    },
  },
}
</script>

<style lang="scss">
  * {
    font-family: 'Unistra A', sans-serif;
    font-size: 17px;
  }
</style>
